// extracted by mini-css-extract-plugin
module.exports = {"counter":"CarshoppingButton_counter__1-Bf7"};